import { createAction } from '@reduxjs/toolkit'

export const updateFetching = createAction<{ fetching: boolean }>('user/updateFetching')
export const updateConnected = createAction<{ connected: boolean }>('user/updateConnected')
export const updateAddress = createAction<{ address: string }>('user/updateAddress')
export const updateEthBalance = createAction<{ ethBalance: string }>('user/updateEthBalance')
export const updateMarsRiseBalance = createAction<{ marsriseBalance: string }>('user/updateMarsRiseBalance')
export const updateNFTAllowance = createAction<{ nftAllowance: string }>('user/updateNFTAllowance')
export const updateLotteryAllowance = createAction<{ lotteryAllowance: string }>('user/updateLotteryAllowance')